import React from 'react';
import AdminDashBoard from 'components/AdminDashBoard/AdminDashBoard';

function DoctorAdminDashboard() {
  return <AdminDashBoard />;
}

export default DoctorAdminDashboard;
